'use client';

import { FC, useEffect } from 'react';

/** Full document navigation for `/forms` routes (e.g. microfrontend handoff). */
export function fullNavigationPush(url: string): void {
  globalThis.window?.location.assign(url);
}

export function fullNavigationReplace(url: string): void {
  globalThis.window?.location.replace(url);
}

/** Hard navigation redirect for routes outside the forms app (e.g. `/`). */
export const FullPageRedirect: FC<{ url: string }> = ({ url }) => {
  useEffect(() => {
    fullNavigationReplace(url);
  }, [url]);

  return null;
};
